import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-09a10550"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "step-button__inner" }
const _hoisted_2 = { class: "step-button__number" }

import { IonText } from '@ionic/vue';
import BaseButton from '@/components/BaseButton.vue';
import BaseIcon from '@/components/BaseIcon.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'StepButton',
  props: {
    order: {},
    label: {},
    icon: {},
    isValid: { type: Boolean },
    value: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseButton, {
    class: "step-button",
    color: "light"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.order), 1),
        _createVNode(BaseIcon, {
          class: "step-button__icon",
          icon: _ctx.icon
        }, null, 8, ["icon"]),
        _createVNode(_unref(IonText), { class: "step-button__label" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.label), 1)
          ]),
          _: 1
        }),
        (_ctx.isValid)
          ? (_openBlock(), _createBlock(_unref(IonText), {
              key: 0,
              class: "step-button__value"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.value), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}
}

})